import { apiConnector } from 'apiConnector/secondary-market-blotter';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import type { AppState } from 'state/state.model';
import { getLifecyclePortalUrl } from 'state/user';
import { httpClient } from 'utils/http.old/httpClient';

import Component from '../Component';

const apiConnected = apiConnector(httpClient);

const SecondaryTradeBlotter: FC = () => {
  const lifecyclePortalUrl = useSelector((state: AppState) => getLifecyclePortalUrl(state));

  return <Component api={apiConnected} lifecyclePortalUrl={lifecyclePortalUrl} />;
};

export default SecondaryTradeBlotter;
